export const LEASE_FROM_SEARCH_PARAM = 'lease-from'
export const LEASE_TO_SEARCH_PARAM = 'lease-to'
export const LEASE_DOWNPAYMENT_FROM_SEARCH_PARAM = 'lease-downpayment-from'
export const LEASE_DOWNPAYMENT_TO_SEARCH_PARAM = 'lease-downpayment-to'
export const DURATION_SEARCH_PARAM = 'duration'
export const YEARLY_MILEAGE_SEARCH_PARAM = 'yearly-mileage'
export const WITH_VAT_SEARCH_PARAM = 'with-vat'
